import { render, staticRenderFns } from "./productSpec.vue?vue&type=template&id=776249f5&scoped=true"
import script from "./productSpec.vue?vue&type=script&lang=js"
export * from "./productSpec.vue?vue&type=script&lang=js"
import style0 from "./productSpec.vue?vue&type=style&index=0&id=776249f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776249f5",
  null
  
)

export default component.exports